// src/components/Footer.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goHomeTop = () => {
    if (location.pathname === "/") {
      scrollToTop();
    } else {
      navigate("/");
    }
  };

  const goHomeSection = (id) => {
    if (location.pathname === "/") {
      scrollToId(id);
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="bg-[#102216] text-white">
      <div className="container mx-auto px-4 py-12 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="size-8 text-primary">
                <svg
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 3L2 12h3v8h14v-8h3L12 3zm0 2.83L16.17 10H7.83L12 5.83zM18 18H6v-6h12v6z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold">Aserradero Monte Moriah</h3>
            </div>
            <p className="text-sm text-gray-400">
              Calidad y confianza en productos madereros.
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  type="button"
                  onClick={goHomeTop}
                  className="hover:text-primary text-left"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goHomeSection("about")}
                  className="hover:text-primary text-left"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goHomeSection("catalog")}
                  className="hover:text-primary text-left"
                >
                  Catálogo
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goHomeSection("gallery")}
                  className="hover:text-primary text-left"
                >
                  Galería
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goHomeSection("contact")}
                  className="hover:text-primary text-left"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">Contacto</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-base">
                  location_on
                </span>
                Caserio santa isabel, 1 calle 1-117 zona 4 santa lucias milpas
                altas
              </li>
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-base">call</span>
                +502 47222020
              </li>
              <li className="flex items-center gap-2">
                <span className="material-symbols-outlined text-base">mail</span>
                vickyleivacastillo04@gmail.com
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
          <p>© 2025 Aserradero Monte Moriah. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
